import { useTranslation } from "react-i18next";
import { labelFor } from "../services/enumLabels";

const TONES = {
  active: "bg-accent-wash text-accent-text",
  draft: "bg-raised text-ink-2",
  closed: "bg-warning-wash text-warning-text",
};

/** active | draft | closed — only an active branch is open to customers. */
export default function BranchStatusBadge({ status }) {
  useTranslation(); // re-render on a language switch: the label is read at render

  if (!status) return null;

  return (
    <span className={`whitespace-nowrap rounded-full px-2 py-1 text-xs ${TONES[status] ?? TONES.draft}`}>
      {labelFor("branch_status", status)}
    </span>
  );
}
